import { LogoutAsSplash } from 'src/components/logout-as-splash';

import { loggedInAsAdvisorID } from '@savvy/deprecated-shared/utils/savvy-auth';

import { AuthGuard } from '../components/authentication/auth-guard';

export function withAdvisorGuard<P extends object>(Component: React.ComponentType<P>) {
  function WithAdvisorGuard(props: P) {
    const isAdvisorLoggedInAsClient = !!loggedInAsAdvisorID();

    if (isAdvisorLoggedInAsClient) return <LogoutAsSplash />;
    return (
      <AuthGuard forAdvisor>
        <Component {...props} />
      </AuthGuard>
    );
  }

  return WithAdvisorGuard;
}
